import React, { useEffect, useState } from 'react';
import { apiRequest } from '@support/api';
import {
  Section,
  SettingsInlineButton,
  SettingsSectionBox,
  SettingsSectionLabel,
  SettingsSectionRow,
} from '@views/Settings/components';

const checkIfOfferPreviouslyAccepted = async (
  setAcceptedOffers: (acceptances: { id: number }[]) => void,
  signal: AbortSignal,
) => {
  try {
    const acceptances = await apiRequest<any>('GET', '/campaign-opt-in/', {}, { apiVersion: 'v2' });

    if (signal.aborted) {
      return;
    }

    if (acceptances.count && acceptances.count > 0) {
      setAcceptedOffers(acceptances.results);
    }
  } catch (e) {
    console.error(e);
  }
};

export default function AcceptedOffers() {
  const [acceptedOffers, setAcceptedOffers] = useState(null);

  async function deleteOffer(id: number): Promise<void> {
    try {
      await apiRequest<{}>('DELETE', `/campaign-opt-in/${id}/`, undefined, { apiVersion: 'v2' });
      setAcceptedOffers(acceptedOffers.filter((acceptance) => acceptance.id != id));
    } catch (e) {
      console.error(e);
    }
  }

  useEffect(() => {
    const abortController = new AbortController();
    checkIfOfferPreviouslyAccepted(setAcceptedOffers, abortController.signal);
    return () => abortController.abort();
  }, []);

  if (!acceptedOffers || acceptedOffers?.length == 0) {
    return null;
  }

  return (
    <Section>
      <SettingsSectionLabel>Accepted Offers</SettingsSectionLabel>
      <SettingsSectionBox>
        {acceptedOffers.map((acceptance, idx) => (
          <SettingsSectionRow key={idx} style={{ justifyContent: 'space-between' }}>
            Offer {acceptance.id} ({acceptance.campaign})
            <SettingsInlineButton onClick={() => deleteOffer(acceptance.id)}>
              Delete
            </SettingsInlineButton>
          </SettingsSectionRow>
        ))}
      </SettingsSectionBox>
    </Section>
  );
}
